import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { TableCellWithOverflow } from 'components/list/TableComponentsStyled';
import ScheduleTypeCellParamTemplateDetailsRowComponent from './ScheduleTypeCellParamTemplateDetailsRowComponent';
import { sequence } from '@totalsoft/change-tracking-react';

export const ScheduleTypeCellParamTemplateDetailsListView = ({
  scheduleCellParamColumns,
  isEditable,
  lens
}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {scheduleCellParamColumns.map(n => {
              return (
                <Tooltip title={n.cellParamDisplayName} key={n.cellParamId}>
                  <TableCellWithOverflow>
                    <strong>{n.cellParamDisplayName}</strong>
                  </TableCellWithOverflow>
                </Tooltip>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {sequence(lens.scheduleTypeCellParamTemplateDetails).map((item, index) => {
            return (
              <ScheduleTypeCellParamTemplateDetailsRowComponent
                scheduleCellParamColumns={scheduleCellParamColumns}
                key={index}
                rowIdx={index}
                rowDataLens={item}
                isEditable={isEditable}
                lens={lens}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

ScheduleTypeCellParamTemplateDetailsListView.propTypes = {
  scheduleCellParamColumns: PropTypes.array.isRequired,
  isEditable: PropTypes.bool.isRequired,
  lens: PropTypes.object.isRequired
};

export default ScheduleTypeCellParamTemplateDetailsListView;
